import React from "react";
import "./Contact.css";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, FaFileAlt } from "react-icons/fa";

function Contact() {
  return (
    <section className="contact" id="contact">
      <h2 className="contact-title">CONTACT US</h2>

      {/* Contact Info Row */}
      <div className="contact-info">
        <div className="contact-item">
          <FaPhoneAlt className="contact-icon" />
          <h3>Call Today</h3>
          <p>(561)-629-7749</p>
        </div>

        <div className="contact-item">
          <FaMapMarkerAlt className="contact-icon" />
          <h3>Address</h3>
          <p>6715 White Drive, Riviera Beach, FL, 33407</p>
        </div>

        <div className="contact-item">
          <FaEnvelope className="contact-icon" />
          <h3>Email</h3>
          <p>
            <a href="mailto:hr@wrightbrotherscs.com">
              hr@wrightbrotherscs.com
            </a>
          </p>
        </div>

        <div className="contact-item">
          <FaFileAlt className="contact-icon" />
          <h3>Email Your Resume</h3>
          <p>For Full Time/Part Time Position</p>
          <br/>
          <p>
            <a href="mailto:hr@wrightbrotherscs.com">
              hr@wrightbrotherscs.com
            </a>
          </p>
        </div>
      </div>


      {/* Social Media Icons Row */}
      <div className="contact-socials">
        <div className="contact-social-item">
          <a href="https://www.linkedin.com/company/wright-brothers-contracting-services/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <svg width="44" height="44" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm15.5 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.967v5.7h-3v-10h2.881v1.367h.041c.401-.761 1.379-1.563 2.841-1.563 3.039 0 3.6 2.001 3.6 4.601v5.595z"/></svg>
          </a>
          <span className="contact-social-label">LinkedIn</span>
        </div>
        <div className="contact-social-item">
          <a href="https://www.facebook.com/WrightBrothersCS" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg width="44" height="44" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35c-.733 0-1.325.592-1.325 1.326v21.348c0 .733.592 1.326 1.325 1.326h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.312h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.326v-21.349c0-.734-.593-1.326-1.324-1.326z"/></svg>
          </a>
          <span className="contact-social-label">Facebook</span>
        </div>
        <div className="contact-social-item">
          <a href="https://www.instagram.com/wrightbrotherscs/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg width="44" height="44" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.241 1.308 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.241 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.241-1.308-3.608-.058-1.266-.069-1.646-.069-4.85s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608.974-.974 2.241-1.246 3.608-1.308 1.266-.058 1.646-.069 4.85-.069zm0-2.163c-3.259 0-3.667.012-4.947.07-1.276.058-2.687.334-3.678 1.325-.991.991-1.267 2.402-1.325 3.678-.058 1.28-.07 1.688-.07 4.947s.012 3.667.07 4.947c.058 1.276.334 2.687 1.325 3.678.991.991 2.402 1.267 3.678 1.325 1.28.058 1.688.07 4.947.07s3.667-.012 4.947-.07c1.276-.058 2.687-.334 3.678-1.325.991-.991 1.267-2.402 1.325-3.678.058-1.28.07-1.688.07-4.947s-.012-3.667-.07-4.947c-.058-1.276-.334-2.687-1.325-3.678-.991-.991-2.402-1.267-3.678-1.325-1.28-.058-1.688-.07-4.947-.07zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881zm0 0"/></svg>
          </a>
          <span className="contact-social-label">Instagram</span>
        </div>
        <div className="contact-social-item">
          <a href="https://x.com/WrightBroCS" target="_blank" rel="noopener noreferrer" aria-label="X">
            <svg width="44" height="44" fill="currentColor" viewBox="0 0 24 24"><path d="M17.53 3.5H21.5l-7.19 8.21L22.5 20.5h-6.02l-4.72-5.41-5.41 5.41H2.5l7.66-8.75L1.5 3.5h6.18l4.18 4.79 4.67-4.79zm-1.06 15.13h1.7l-5.34-6.13-1.7 1.92 5.34 6.13zM4.77 5.13l5.34 6.13 1.7-1.92-5.34-6.13-1.7 1.92z"/></svg>
          </a>
          <span className="contact-social-label">X</span>
        </div>
      </div>

      {/* Divider Line */}
      <div className="contact-divider"></div>

      {/* Map Embed */}
      <div className="contact-map">
        <iframe
          title="company-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3585.236002812123!2d-80.0680133!3d26.7781359!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d8d52f8a8e5e3f%3A0x25a98dba2c5fbb1f!2s6715%20White%20Dr%2C%20Riviera%20Beach%2C%20FL%2033407!5e0!3m2!1sen!2sus!4v1676231234567"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}

export default Contact;
